import type { ReactNode } from 'react';
import { getMessageViewRenderer } from '../selectors/registry';

interface ComponentMessageViewProps {
    componentType: string;
    data: unknown;
}

export function ComponentMessageView({
    componentType,
    data,
}: ComponentMessageViewProps): ReactNode {
    const renderer = getMessageViewRenderer(componentType);
    if (!renderer) {
        return <FallbackMessageView data={data} />;
    }
    return <>{renderer(data)}</>;
}

function FallbackMessageView({ data }: { data: unknown }): ReactNode {
    // Show a sensible text representation when renderer is unavailable
    const text =
        typeof data === 'object' && data !== null && 'name' in data
            ? (data as { name: string }).name
            : JSON.stringify(data);
    return <span>{text}</span>;
}
